import { styled as muiStyled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { abyssColors } from '@/theme/colors';
export const paperStyles = {
  borderRadius: '0.8rem',
  boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.15)',
  maxWidth: '47.2rem',
};

export const titleStyles = {
  padding: '2.4rem',
  paddingBottom: '1.6rem',
  typography: 'h4',
};

export const contentStyles = {
  padding: '2.4rem',
  paddingTop: '0',
};
export const pointOfInterestTabsStyles = {
  pt: 2,
  '& .MuiTab-root': {
    padding: '0 16px',
    minWidth: 0,
    minHeight: 'min-content',
    height: '26px',
    textTransform: 'none',
    border: 'none',
  },
  '& .MuiTab-root.Mui-selected': {
    backgroundColor: `${abyssColors.primary[100]} !important`,
    borderRadius: '4px',
  },
  '& .MuiTabs-indicator': {
    height: '0rem',
    border: 'none',
  },
};
export const TablePaginationContainer = muiStyled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  backgroundColor: abyssColors.primary[50],
}));
export const feedbackContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  py: 7,
};
